import React, { useState, useRef, useEffect } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { EditIcon, DeleteIcon } from 'components/SVG';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import type { CSSProperties } from 'react';
import EditableTitleSkeleton from 'sharedComponents/Skeleton/EditableTitleSkeleton';
import { Box, BoxProps } from '@mui/material';
import SparkEditableText from './SparkEditableText';

interface EditableTextFieldProps {
  startAdornment?: React.ReactNode;
  value: string | undefined | null;
  onTitleSave: (newValue: string) => void;
  onDelete?: () => void;
  shouldDeleteIcon?: boolean;
  sx?: TextFieldProps['sx'];
  inputStyle?: CSSProperties;
  isParentLoading?: boolean;
  fullWidth?: boolean;
  containerStyle?: BoxProps['sx'];
  characterLengthOffSet?: number;
  placeholder?: string;
}

const SparkEditableTitle: React.FC<EditableTextFieldProps> = ({
  startAdornment = <></>,
  value = '',
  onTitleSave,
  onDelete,
  shouldDeleteIcon = false,
  sx = {},
  inputStyle = {},
  isParentLoading = false,
  placeholder = '',
  fullWidth = false,
  containerStyle = {},
  characterLengthOffSet = 0,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = React.useState<string | null>(null);

  React.useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const shouldRenderDeleteIcon = shouldDeleteIcon && onDelete;

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setInputValue(value);
    setIsEditing(false);
  };

  const handleSaveClick = () => {
    if (inputRef.current) {
      onTitleSave(inputRef.current.value);
    }
    setIsEditing(false);
  };

  if (isParentLoading) {
    return <EditableTitleSkeleton />;
  }
  return (
    // <SparkEditableText
    //   initialText={value || ''}
    //   onTextChange={onTitleSave}
    //   containerStyles={{ paddingLeft: 2, paddingRight: 2 }}
    // />

    <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      {startAdornment && <>{startAdornment}</>}
      <SparkEditableText
        initialText={value || ''}
        onTextChange={onTitleSave}
        containerStyles={{ paddingLeft: 1 }}
      />
    </Box>
  );
  // return (
  //   <Box width='auto' display='flex' alignItems='center' sx={containerStyle}>
  //     <TextField
  //       value={inputValue}
  //       inputRef={inputRef}
  //       disabled={!isEditing}
  //       onChange={(e) => setInputValue(e.target.value)}
  //       onClick={(e) => e.stopPropagation()}
  //       placeholder={placeholder}
  //       fullWidth={fullWidth}
  //       size='small'
  //       sx={{
  //         '& input': {
  //           border: 'none',
  //           width: `${
  //             inputValue ? inputValue.length + characterLengthOffSet : 10
  //           }ch`,
  //           maxWidth: '200px',
  //           ...inputStyle,
  //         },
  //         '& fieldset': { border: 'none' },
  //         '& .MuiInputBase-root': { padding: 0 },
  //         '& :focus': { bgcolor: 'none' },
  //         '& .MuiInputBase-input.Mui-disabled': {
  //           WebkitTextFillColor: '#000',
  //         },
  //         '& .MuiInputAdornment-root': {
  //           marginLeft: 0,
  //         },
  //         fontFamily: 'Mont-SemiBold',
  //         fontSize: 24,
  //         backgroundColor: 'inherit',
  //         ...sx,
  //       }}
  //       autoComplete='off'
  //       InputProps={{
  //         startAdornment: startAdornment ? (
  //           <InputAdornment position='start'>{startAdornment}</InputAdornment>
  //         ) : (
  //           <></>
  //         ),
  //       }}
  //     />
  //     <InputAdornment position='end'>
  //       {isEditing ? (
  //         <>
  //           <IconButton onClick={handleCancelClick}>
  //             <ClearIcon sx={{ color: '#000', width: '20px' }} />
  //           </IconButton>
  //           <IconButton onClick={handleSaveClick}>
  //             <CheckIcon sx={{ color: '#000', width: '20px' }} />
  //           </IconButton>
  //         </>
  //       ) : (
  //         <IconButton onClick={handleEditClick}>
  //           <EditIcon color='#000' width='15px' />
  //         </IconButton>
  //       )}
  //       {shouldRenderDeleteIcon && (
  //         <IconButton onClick={onDelete}>
  //           <DeleteIcon color='#000' height='18px' />
  //         </IconButton>
  //       )}
  //     </InputAdornment>
  //   </Box>
  // );
};

export default SparkEditableTitle;
